var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { CacheClient, CacheLocation } from "../basics/client-caching.service";
import { autoinject } from "aurelia-dependency-injection";
import { RequestClient } from "../basics/request-client.service";
import { LookupValueRequest, LookupValueQuery } from "../../models/lookups/lookup.models";
import * as LookupConstants from "../../constants/lookups/lookup.constants";
import { BindingEngine } from "aurelia-binding";
import { ArrayUtils } from "../../utilities/arrays";
import { Guid } from "../../utilities/guid";
import { CacheCategory } from "../../constants/lookups/lookup.constants";
import { DateHelper } from "../../utilities/date-helper";
import { TokenClient } from "../authentication/token-client.service";
import * as Enumerable from "linq";
import { toNative } from "../../utilities/promise-utils";
var LookupClientService = /** @class */ (function () {
    function LookupClientService(requestClient, bindingEngine, tokenClient, cachingService) {
        this.requestClient = requestClient;
        this.bindingEngine = bindingEngine;
        this.tokenClient = tokenClient;
        this.cachingService = cachingService;
        this.cacheFlag = [];
        this.subscriptions = [];
    }
    LookupClientService.prototype.clearLookupCache = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var request;
        if (args && args[0] instanceof LookupValueRequest) {
            request = args[0];
        }
        else if (typeof args[0] == "string" && typeof args[1] == "string") {
            request = new LookupValueRequest(args[0], args[1]);
        }
        else if (typeof args[0] == "string") {
            request = new LookupValueRequest(args[0]);
        }
        return new Promise(function (resolve, reject) {
            _this.cachingService.remove(request.getCacheKey()).then(function (response) {
                _this.subscriptions.filter(function (y) { return y.query == request.lookupValueQuery && y.params == request.parameters; }).forEach(function (x) {
                    x.func();
                });
                resolve(undefined);
                return;
            }).catch(function (ex) {
                reject();
                return;
            });
        });
    };
    LookupClientService.prototype.clearLookupCacheFull = function (lookupName, parameters) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.clearLookupCache(lookupName, parameters);
            _this.requestClient.post("".concat(LookupConstants.Urls.ClearCache, "/").concat(lookupName)).then(function (res) { return resolve(); }, function (err) { return reject(); });
        });
    };
    LookupClientService.prototype.clearAllLookups = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.cachingService.removeKeyContains(CacheCategory.lookups);
            resolve();
        });
    };
    LookupClientService.prototype.subscribeForLookupsRefresh = function (query, params, func) {
        if (!this.subscriptions) {
            this.subscriptions = [];
        }
        this.subscriptions.push({ query: query, params: params, func: func });
    };
    LookupClientService.prototype.unsubscribeForLookupsRefresh = function (query, params, func) {
        if (this.subscriptions) {
            var index = ArrayUtils.findIndex(this.subscriptions, function (x) { return x.func == func && x.query == query && x.params == params; });
            if (index > -1) {
                this.subscriptions.splice(index, 1);
            }
        }
    };
    LookupClientService.prototype.getLookup = function (getLookupRequest, createFlag, expiryTimeInSeconds) {
        var _this = this;
        if (createFlag === void 0) { createFlag = true; }
        if (expiryTimeInSeconds === void 0) { expiryTimeInSeconds = 20; }
        if (getLookupRequest) {
            return new Promise(function (res, rej) {
                var found = _this.cacheFlag.filter(function (x) { return x.flag == _this.lookupRequestToString(getLookupRequest); })[0];
                if (!found) { //We are NOT currently doing an identical call to the server, proceed
                    if (createFlag) {
                        _this.cacheFlag.push({ flag: _this.lookupRequestToString(getLookupRequest), response: null, expiryTimer: null, expiryTimeInSeconds: expiryTimeInSeconds, successfull: null, subscribers: [] });
                    }
                    _this.getData(getLookupRequest).then(function (x) {
                        var result = _this.filterDataByBrand(x);
                        res(result);
                    }, rej);
                }
                else { // We have an identical call currently processing, wait for it and return that data
                    _this.waitForData(getLookupRequest).then(function (x) {
                        var result = _this.filterDataByBrand(x);
                        res(result);
                    }, rej);
                }
            });
        }
        else {
            return new Promise(function (resolve, reject) {
                reject();
            });
        }
    };
    LookupClientService.prototype.filterDataByBrand = function (response) {
        if (this.tokenClient.isSuperAdmin())
            return response;
        if (response.lookupValueQuery.toLowerCase() == LookupValueQuery.brands.toLowerCase()) {
            var userBrands = Enumerable.from(this.tokenClient.user.userBrands).select(function (x) { return x.brandId; });
            response.values = Enumerable.from(response.values).where(function (x) { return userBrands.contains(x.id); }).toArray();
        }
        else if (response.lookupValueQuery.toLowerCase() == LookupValueQuery.operators.toLowerCase()) {
            var userOperators = Enumerable.from(this.tokenClient.user.userOperators).select(function (x) { return x.operatorId; });
            response.values = Enumerable.from(response.values).where(function (x) { return userOperators.contains(x.id); }).toArray();
        }
        return response;
    };
    LookupClientService.prototype.getData = function (getLookupRequest) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.cachingService.get(getLookupRequest.getCacheKey(), CacheLocation.LocalStorage).then(function (cachedResponse) {
                if (!cachedResponse || !cachedResponse.values) {
                    cachedResponse = {
                        lastModifiedDate: null,
                        values: [],
                        lookupValueQuery: getLookupRequest.lookupValueQuery,
                        parameters: getLookupRequest.parameters,
                        defaultValue: null
                    };
                }
                getLookupRequest.clientLastModifiedDate = cachedResponse.lastModifiedDate;
                _this.doRequest(getLookupRequest).then(function (response) {
                    var func = function () {
                        var index = ArrayUtils.findIndex(_this.cacheFlag, function (x) { return x.flag == _this.lookupRequestToString(getLookupRequest); });
                        var cacheFlag = _this.cacheFlag[index];
                        if (index > -1) {
                            cacheFlag.response = cachedResponse;
                            if (cacheFlag.subscribers.length == 0) {
                                _this.cacheFlag.splice(index, 1);
                            }
                            cacheFlag.successfull = true;
                        }
                        resolve(cachedResponse);
                    };
                    if (!cachedResponse.lastModifiedDate || DateHelper.castDate(response.lastModifiedDate) > DateHelper.castDate(cachedResponse.lastModifiedDate)) {
                        _this.cachingService.put(getLookupRequest.getCacheKey(), response).then(function (x) {
                            cachedResponse = response;
                            func();
                        });
                    }
                    else {
                        func();
                    }
                }).catch(function () {
                    var index = ArrayUtils.findIndex(_this.cacheFlag, function (x) { return x.flag == _this.lookupRequestToString(getLookupRequest); });
                    var cacheFlag = _this.cacheFlag[index];
                    if (index > -1) {
                        cacheFlag.response = null;
                        if (cacheFlag.subscribers.length == 0) {
                            _this.cacheFlag.splice(index, 1);
                        }
                        cacheFlag.successfull = false;
                    }
                    reject();
                });
            });
        });
    };
    LookupClientService.prototype.waitForData = function (getLookupRequest) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var guid = Guid.generateGuid();
            var index = ArrayUtils.findIndex(_this.cacheFlag, function (x) { return x.flag == _this.lookupRequestToString(getLookupRequest); });
            var cacheFlag = _this.cacheFlag[index];
            if (cacheFlag.successfull != null) {
                if (cacheFlag.successfull) {
                    resolve(cacheFlag.response);
                }
                else {
                    reject(cacheFlag.response);
                }
                return;
            }
            cacheFlag.subscribers.push(guid);
            var subscription = _this.bindingEngine.propertyObserver(cacheFlag, "successfull")
                .subscribe(function (newValue) {
                subscription.dispose();
                if (newValue) {
                    resolve(cacheFlag.response);
                }
                else {
                    reject(cacheFlag.response);
                }
                cacheFlag.subscribers.splice(cacheFlag.subscribers.indexOf(guid), 1);
                if (cacheFlag.subscribers.length == 0) {
                    cacheFlag.expiryTimer = setTimeout(function () {
                        cacheFlag.expiryTimer = null;
                        _this.cacheFlag.splice(ArrayUtils.findIndex(_this.cacheFlag, function (x) { return x.flag == _this.lookupRequestToString(getLookupRequest); }), 1);
                    }, cacheFlag.expiryTimeInSeconds * 1000);
                }
            });
        });
    };
    LookupClientService.prototype.doRequest = function (getLookupRequest) {
        return toNative(this.requestClient.get(LookupConstants.Urls.GetLookup, getLookupRequest, false, false));
    };
    LookupClientService.prototype.getTableMetadata = function () {
        return toNative(this.requestClient.get(LookupConstants.Urls.GetTableMetaDatas, null, false));
    };
    LookupClientService.prototype.getLookupColumns = function (columnId) {
        return toNative(this.requestClient.get(LookupConstants.Urls.GetTableColumnMetaDatas + "/" + columnId + "/1/20"));
    };
    LookupClientService.prototype.updateLookupValues = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient.post(LookupConstants.Urls.UpdateLookupValues, {}, request).then(function (x) {
                if (x.exceptionNumber === 547) {
                    reject(x);
                }
                resolve(x);
            }, function (e) {
                reject();
            });
        });
    };
    LookupClientService.prototype.updateLookupsOrdering = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.requestClient.post(LookupConstants.Urls.UpdateLookupsOrdering, {}, request).then(function (response) {
                if (response.exceptionNumber === 547) {
                    reject(response);
                }
                resolve(response);
            }, function (error) {
                reject();
            });
        });
    };
    LookupClientService.prototype.lookupRequestToString = function (getLookUpRequest) {
        return getLookUpRequest.lookupValueQuery + " " + getLookUpRequest.parameters;
    };
    LookupClientService = __decorate([
        autoinject,
        __metadata("design:paramtypes", [RequestClient,
            BindingEngine,
            TokenClient,
            CacheClient])
    ], LookupClientService);
    return LookupClientService;
}());
export { LookupClientService };
